import { useCmdAuth } from "../contexts/CmdAuthContext";

/**
 * Front-end mirror of the back-end permission engine.
 * The server is still the source of truth — this hook only hides UI the user cannot use.
 *
 *   const perms = usePermissions();
 *   perms.can("financials", "edit");  // true/false
 *   perms.visible("access");          // true if level is at least "view"
 */
export function usePermissions() {
  const { me } = useCmdAuth();
  const perms = me?.permissions || {};
  const role = me?.role || "Unassigned";
  const isFounder = !!me?.is_founder;

  const rank = (l) => (l === "edit" ? 2 : l === "view" ? 1 : 0);

  function levelOf(module) {
    if (isFounder) return "edit";
    // Synthetic module: Capital is open to Founder, Investor (own line + group), and anyone with financials access.
    if (module === "capital") {
      if (role === "Investor") return "view";
      const fin = perms.financials || "none";
      return fin === "none" ? "none" : "view";
    }
    // Hard rule mirror: Investor is blocked from raw financials.
    if (role === "Investor" && module === "financials") return "none";
    return perms[module] || "none";
  }

  function can(module, needed) {
    return rank(levelOf(module)) >= rank(needed);
  }

  function visible(module) {
    return levelOf(module) !== "none";
  }

  return { role, isFounder, verticals: me?.verticals || [], can, visible, levelOf };
}
